import React, { useState, useEffect } from 'react';
import { Grid, Paper, Button } from "@material-ui/core";
import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview } from "../../actions/GenomicsResearchAction";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Link } from "react-router-dom";
import Libarary from './PDf/p5.jpg';
import Library1 from './PDf/p6.jpg'
// import "./dashboard.css";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);
const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);


interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    loading,
}) => {
    const classes = useStyles();

    const openPDF1 = () => {
        window.open('https://static-redcliffelabs.s3.ap-south-1.amazonaws.com/media/betatest/2023/7/12/1689144193461_media_betatest_2023_7_12_1689144034062_1687774798513_SO-08-22-574_SampleQC.pdf', '_blank');
    };
    const openPDF = () => {
        window.open('https://static-redcliffelabs.s3.ap-south-1.amazonaws.com/media%2Fbetatest%2F2023%2F6%2F26%2F1687778522446_SO-08-22-574_DataQC+%282%29_compressed.pdf', '_blank');
    };
    const openPDF2 = () => {
        window.open('https://static-redcliffelabs.s3.ap-south-1.amazonaws.com/media/betatest/2023/6/26/1687774620441_SO-08-22-574%20Closing%20report.pdf', '_blank');
    };
    return (
        <div style={{ width: "100%", margin: "60px auto" }}>
            <div style={{ backgroundColor: "#0b2857", border: "2px solid #0b2857", borderRadius: "10px" }}>
                <h2 style={{ textAlign: "center", color: "white" }}>2022-2023</h2>
            </div>
            <div style={{ margin: "10px 0px 0px 0px" }} id="geno">
                <div className="cardsAppointment" style={{ display: 'flex', flexDirection: 'row', alignItems: "flex-start" }}>
                    <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold', textAlign: "center" }} onClick={openPDF1}>Sample QC Report
                                </h5>
                            </Grid>
                        </Grid>
                    </div>
                    {/* <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }} onClick={openPDF2}>Library QC Report</h5>
                            </Grid>
                        </Grid>
                    </div> */}
                    <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold', textAlign: "center" }} onClick={openPDF}>Data QC Report</h5>
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold', textAlign: "center" }} onClick={openPDF2}>Final Report</h5>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
            <Paper>
                <TableContainer
                    className={classes.tableContainer}
                    component={Paper}
                    style={{ maxHeight: "480px", marginTop: "5px" }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <StyledTableRow>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow >
                                <StyledTableCell align="center">
                                    <a href="https://drive.google.com/drive/folders/1fuIzcklOGP8-2PLK6zooBr6-zd47xOZh?usp=sharing" target="_blank" rel="noopener noreferrer">Raw data link</a>
                                </StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow >
                                <StyledTableCell align="center">
                                    <a href="https://static-redcliffelabs.s3.ap-south-1.amazonaws.com/media/betatest/2023/6/26/1687775942395_Screenshot%20from%202023-06-26%2016-08-18.png" target="_blank" rel="noopener noreferrer">Vcf file link</a>
                                </StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow >
                                <StyledTableCell align="center">
                                    <a href="https://drive.google.com/drive/folders/1yc30WYvyA5zbyr1GLmnespDNI5jc_kMN?usp=drive_link" target="_blank" rel="noopener noreferrer">Final Result</a>
                                </StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <Grid xs={2}>
                <Link
                    to={`/dashboard/gnre/genom_data_share`}
                    style={{ textDecoration: "none" }}
                >
                    <Button
                        variant="contained"
                        type="submit"
                        style={{ width: 300, background: "#0a5a66", color: "white" }}
                    >
                        Data Sharing
                    </Button>
                </Link>
            </Grid>
        </div >
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
})(Dashboard);